/**
 * Constants that are used in BI data
 */

import { OrderItem } from '../../../types/OrderItem';

export const BiPpWp = 'WP';
export const BiPpPayPal = 'PayPal';
export const BiPmGooglePay = 'googlePay';
export const BiPmApplePay = 'applePay';
export const BiPmPayPal = 'payPal';
export const BiShippingContact = 'shippingContact';
export const BiShippingMethod = 'shippingMethod';
export const BiOriginProduct = 'product';
export const BiOriginCart = 'cart';

export const longMulti = 100000;

// 458 ev ecwGettingPaymentDataFromVertical
export const EvStepNameInitialization = 'initialization';
export const EvStepNameResult = 'result';
export const EvResultSuccess = 'success';
export const EvResultFailure = 'failure';

export const getOrderTypeByItems = (orderItems?: OrderItem[]) => orderItems?.map((o) => o.category).join();
